import { isEmpty } from 'lodash';
import { QuoteUrlConstant } from 'src/constants';
import {
  GetQuoteChartDto,
  GetQuoteChartResponseDto,
  GetQuoteDto,
  GetQuoteListDto,
  GetQuoteListResponseDto,
  QuoteDetailsDto,
} from 'src/dtos';
import { WithAuthToken, replacePlaceholders, httpRequest } from 'src/utils';

export class QuoteApi {
  async list({ queryParams, authToken }: WithAuthToken<GetQuoteListDto>): Promise<GetQuoteListResponseDto> {
    if (isEmpty(queryParams.symbols)) {
      return {
        quotedata: [],
        symbolcount: 0,
        copyright: '',
      };
    }

    return httpRequest<GetQuoteListResponseDto>({
      method: 'GET',
      url: QuoteUrlConstant.LIST,
      queryParams,
      authToken,
    });
  }

  async retrieve({ params, authToken }: WithAuthToken<GetQuoteDto>): Promise<QuoteDetailsDto> {
    const url = replacePlaceholders(QuoteUrlConstant.RETRIEVE, {
      symbol: params.symbol,
    });

    return httpRequest<QuoteDetailsDto>({
      method: 'GET',
      url,
      authToken,
    });
  }

  async retrieveChart({
    params,
    queryParams,
    authToken,
  }: WithAuthToken<GetQuoteChartDto>): Promise<GetQuoteChartResponseDto> {
    const url = replacePlaceholders(QuoteUrlConstant.GET_CHART, {
      symbol: params.symbol,
    });

    return httpRequest<GetQuoteChartResponseDto>({
      method: 'GET',
      url,
      queryParams,
      authToken,
    });
  }
}
